export default "/assets/images/the-home-wrecker-crop.webp?05eb9bb08552e4707043346dffdd8e85";